import { object, string } from "yup";
import { nonEmptyRequiredString, practitioner } from "../shared.js";
import { disclosureHarmfulSchema, soadAssessmentCompletionStatusSchema, } from "./helpers.js";
import { exampleSRFData } from "./srf.js";
export const soadCTO11Part1DataSchema = object({
    practitioner: practitioner(),
    treatmentNotRecalled: nonEmptyRequiredString.required("Please include a description of treatment or plan of treatment"),
    conditionsNotRecalled: string().nullable().default(null),
    treatmentAfterRecall: string().nullable().default(null),
    conditionsAfterRecall: string().nullable().default(null),
    reasons: nonEmptyRequiredString.required("Please include your reasons"),
    disclosureHarmful: disclosureHarmfulSchema,
    completionStatus: soadAssessmentCompletionStatusSchema,
});
// Example data
const patient = {
    name: "John Doe",
    address: "123 address",
    postalCode: "SE4",
    dateOfBirth: null,
};
const user = {
    name: "Dr Bob",
    email: "bob@bob.com",
    address: "123 hospital",
    postalCode: "SE5",
    isGuest: false,
    isConfirmed: true,
};
export const exampleSoadCTO11Data = [
    {
        data: {
            practitioner: user,
            treatmentNotRecalled: "Treatment if not recalled",
            conditionsNotRecalled: "Conditions if not recalled",
            treatmentAfterRecall: "Treatment after recall",
            conditionsAfterRecall: "Conditions after recall",
            reasons: "REASONS",
            disclosureHarmful: false,
            completionStatus: "completed",
        },
        context: {
            patient,
            user,
            formContext: { officialReferenceId: "1233445" },
            srfData: exampleSRFData.map(({ data }) => data),
        },
    },
];
//# sourceMappingURL=soad-cto11.js.map